import { useQuery } from "@tanstack/react-query";
import { findProposal } from "../../api/rental-financial-proposal";
import { PreviewProposalDto } from "../../dtos/rental-financial-proposal";
import { AxiosResponse } from "axios";

interface FindProposalProps {
  uid: string;
  enabled?: boolean;
}
export default function useFindProposal({uid, enabled = true}: FindProposalProps) {
  return useQuery<AxiosResponse<PreviewProposalDto>, any, PreviewProposalDto>({
    queryKey: ["financial-proposal", uid],
    queryFn: () => findProposal(uid),
    select: ({ data }) => data,
    enabled
  });
}
